import gql from 'graphql-tag';

export const activateUserMutation = gql`
  mutation activateUser($activateUserRequest: ActivateUserRequest!) {
    activateUser(activateUserRequest: $activateUserRequest) {
      success,
      errors
    }
  }
`;

export const loginUserMutation = gql`
  mutation loginUser($loginUserInput: LoginUserInput){
    loginUser(loginUserInput : $loginUserInput)  {
      expiresIn
      accessToken
    }
  }
`;

export const changePasswordMutation = gql`
  mutation changePasswordWithUserSession($input: ChangePasswordWithUserSessionInput){
    changePasswordWithUserSession(changePasswordWithUserSessionInput: $input)
  }
`;
export const changeUserName = gql`
  mutation changeUserName($input: String){
    changeUserName(newNameInput: $input)
  }
`;
export const changeUserLastName = gql`
  mutation changeUserLastName($input: String){
    changeUserLastName(newLastNameInput: $input)
  }
`;
export const changeUserPhoneNumber = gql`
  mutation changeUserPhoneNumber($input: String){
    changeUserPhoneNumber(newPhoneNumberInput: $input)
  }
`;
export const changeDeliveryMethod = gql`
  mutation changeDeliveryMethod($input: String){
    changeDeliveryMethod(newDeliveryMethodInput: $input)
  }
`;

export const changePasswordWithSecurityToken = gql`
  mutation changePasswordWithSecurityToken($input: ChangePasswordWithSecurityTokenInput){
    changePasswordWithSecurityToken(changePasswordWithSecurityTokenInput: $input)
  }
`;

export const sendEmailForRecoverPasswordMutation = gql`
  mutation sendEmailForRecoverPassword($input: SendEmailForRecoverPasswordInput){
    sendEmailForRecoverPassword(sendEmailForRecoverPasswordInput: $input)
  }
`;

export const deleteLeadsMutation = gql`
  mutation deleteLeads($input: DeleteLeadsInput){
    deleteLeads(deleteLeadsInput: $input)
  }
`;

export const assignLeadsMutation = gql`
  mutation assignLeads($input: AssignLeadsInput){
    assignLeads(assignLeadsInput: $input)
  }
`;

export const unAssignLeadsMutation = gql`
  mutation unAssignLeads($input: UnAssignLeadsInput){
    unAssignLeads(unAssignLeadsInput: $input)
  }
`;

export const assignLeadToMe = gql`
  mutation assignLeadToMe($input: GetLeadByIdInput) {
    assignLeadToMe (getLeadByIdInput: $input)
  }
`;

export const newLeadMutation = gql`
  mutation newLead($input: NewLeadInput) {
    newLead(newLeadInput: $input)
  }
`;

export const importLeadsMutation = gql`
  mutation importLeads($input: LeadsImportInput) {
    importLeads(leadsImportInput: $input)
  }
`;

export const transferLeadsMutation = gql`
  mutation transferLeads($input: TransferLeadsInput){
    transferLeads(transferLeadsInput: $input)
  }
`;

export const unTransferLeadsMutation = gql`
  mutation unTransferLeads($input: UnTransferLeadsInput){
    unTransferLeads(unTransferLeadsInput: $input)
  }
`;

export const editLeadMutation = gql`
  mutation editLead($input: EditLeadInput) {
    editLead (editLeadInput: $input)
  }
`;

export const editLeadsMutation = gql`
  mutation editsLead($input: EditLeadsInput) {
    editLeads (editLeadsInput: $input)
  }
`;

export const notificationTokenMutation = gql`
  mutation notificationToken($input: NotificationTokenInput) {
    notificationToken (notificationTokenInput: $input)
  }
`;

export const deleteNotificationToken = gql`
  mutation deleteNotificationToken {
    deleteNotificationToken
  }
`;

export const sendEmailContact = gql`
  mutation sendEmailContact($input: SendEmailContactInput) {
    sendEmailContact (sendEmailContactInput: $input)
  }
`;

export const sendWhatsAppContact = gql`
  mutation sendWhatsAppContact($input: SendWhatsAppContactInput) {
    sendWhatsAppContact (sendWhatsAppContactInput: $input)
  }
`;

export const doTrack = gql`
  mutation doTrack($input: DoTrackInput) {
    doTrack (doTrackInput: $input)
  }
`;

export const archiveLead = gql`
  mutation archiveLead($input: ArchiveLeadInput) {
    archiveLead (archiveLeadInput: $input)
  }
`;

export const reminderLead = gql`
  mutation reminderLead($input: ReminderLeadInput) {
    reminderLead (reminderLeadInput: $input)
  }
`;

export const closeLead = gql`
  mutation closeLead($input: CloseLeadInput) {
    closeLead (closeLeadInput: $input)
  }
`;

export const revertCloseLead = gql`
  mutation revertCloseLead($input: RevertCloseLeadInput) {
    revertCloseLead (revertCloseLeadInput: $input)
  }
`;

export const visitLead = gql`
  mutation visitLead($input: VisitLeadInput) {
    visitLead (visitLeadInput: $input)
  }
`;

export const makeCall = gql`
  mutation makeCall($input: MakeCallInput) {
    makeCall(makeCallInput: $input){
      inCallLeadId
      result
      callStartTime
    }
  }
`;

export const finishCall = gql`
  mutation finishCall($input: FinishCallInput) {
    finishCall(finishCallInput: $input)
  }
`;

export const transitionToTrack = gql`
  mutation transitionToOnTrack($input: TransitionToOnTrackInput) {
    transitionToOnTrack(transitionToOnTrackInput: $input)
  }
`;

export const visitConfirmation = gql`
  mutation visitConfirmation($input: VisitConfirmationInput) {
    visitConfirmation(visitConfirmationInput: $input)
  }
`;

export const addComment = gql`
  mutation addComment($input: AddCommentInput) {
    addComment(addCommentInput: $input)
  }
`;

export const transferFlag = gql`
  mutation transferFlag($input: TransferredInput) {
    transferFlag(transferredInput: $input)
  }
`;

export const changeCompany = gql`
mutation changeCompany($input: ChangeCompanyInput) {
  changeCompany(changeCompanyInput: $input)
}
`;

export const changeConfigurationCompany = gql`
mutation changeConfiguration($input: ChangeConfigurationInput) {
  changeConfiguration(changeConfigurationInput: $input)
}
`;

export const createEvent = gql`
mutation createEvent($input: CreateEventInput) {
  createEvent(createEventInput: $input)
}
`;

export const createEventWithoutUser = gql`
mutation createEventWithoutUser($input: CreateEventInput) {
  createEventWithoutUser(createEventInput: $input)
}
`;

export const removeEvent = gql`
mutation removeEvent($input: RemoveEventInput) {
  removeEvent(removeEventInput: $input)
 }
`;

export const refreshTokenMutation = gql`
mutation refreshToken($input: String) {
  refreshToken(emailInput: $input) {
      expiresIn
      accessToken
    }
 }
`;

export const editAssignmentRuleMutation = gql`
mutation editAssignmentRule($input: EditAssignmentRuleInput) {
  editAssignmentRule(editAssignmentRuleInput: $input)
 }
`;

export const toggleAssignmentRuleActivationMutation = gql`
mutation toogleAssignmentRuleActivation($input: EditAssignmentRuleInput) {
  toogleAssignmentRuleActivation(editAssignmentRuleInput: $input)
 }
`;

export const deleteAssignmentRuleMutation = gql`
mutation deleteAssignmentRule($input: DeleteAssignmentRuleInput) {
  deleteAssignmentRule(deleteAssignmentRuleInput: $input)
 }
`;

export const newAssignmentRulesMutation = gql`
  mutation newAssignmentRules($input: NewAssignmentRulesInput) {
    newAssignmentRules(newAssignmentRulesInput: $input) {
      successes
      repeatedRules
    }
  }
`;

export const createInvestment = gql`
  mutation createInvestment($input: CreateInvestmentInput) {
    createInvestment(createInvestmentInput: $input)
  }
`;

export const deleteInvestment = gql`
  mutation deleteInvestment($input: DeleteInvestmentInput) {
    deleteInvestment(deleteInvestmentInput: $input)
  }
`;

export const updateInvestment = gql`
  mutation updateInvestment($input: UpdateInvestmentInput) {
    updateInvestment(updateInvestmentInput: $input)
  }
`;
